"use client"

import { Fragment } from "react"
import { usePathname } from "next/navigation"

import { PageViewAnalytics, type PageTemplate } from "@unlikelystudio/react-ecommerce-hooks"

import { AlgoliaAnalyticsEvents } from "~/components/shared/AlgoliaAnalyticsEvents/index.client"
import { AnalyticsEvents } from "~/components/shared/AnalyticsEvents/index.client"
import type { PageName } from "~/components/shared/AnalyticsEvents/types"

type TrackingEventsProps = {
  pageName: PageName
  templateName: PageTemplate
  withAlgoliaEvents?: boolean
}

export function TrackingEvents({ pageName, templateName, withAlgoliaEvents }: TrackingEventsProps) {
  const pathname = usePathname()

  return (
    <Fragment>
      <PageViewAnalytics pathname={pathname} template={templateName} />
      <AnalyticsEvents pageName={pageName} />
      {withAlgoliaEvents && <AlgoliaAnalyticsEvents />}
    </Fragment>
  )
}
